import { createSelector } from '@reduxjs/toolkit';

import accountApi from '@/slices/account/account.api';
import type { User } from '@/slices/account/account.types';
import { createQueryEntitySelectors } from '@/slices/shared/queryEntitySelectors';
import type { RootState } from '@/store';

const selectUsers = (state: RootState): User[] =>
  accountApi.endpoints.getUsers.select()(state).data ?? [];

const usersEntitySelectors = createQueryEntitySelectors<RootState, User>({
  selectList: selectUsers,
});

export const selectUsersById = usersEntitySelectors.selectEntities;
export const selectUserById = (
  state: RootState,
  userId: string,
): User | undefined => {
  if (!userId) {
    return undefined;
  }

  return accountApi.endpoints.getUser.select({ userId })(state).data;
};

const selectCompanyId = (_state: RootState, companyId: string): string =>
  companyId;

export const selectUsersByCompanyId = createSelector(
  [usersEntitySelectors.selectAll, selectCompanyId],
  (users, companyId): User[] => {
    if (!companyId) {
      return [];
    }

    return users.filter((user) => user.company.id === companyId);
  },
);
